/**
 *
 *
 */
class BasicApiFormatter {
  /**
   *
   * @param {*} payload
   * @return {Object}
   */
  static pack(payload) {
    const headers = new Headers();
    const body = new FormData();

    headers.append('Accept', '*/*');
    headers.append('X-Requested-By', 'Enterprise');

    if (typeof payload !== 'undefined') {
      body.append('arguments', JSON.stringify(payload));
    }

    const req = this.getRequestConfig(headers, body);

    return req;
  }

  static getRequestConfig(headers = null, body = null) {
    const req = {
      method: 'POST',
      mode: 'cors',
      credentials: 'include',
    };
    if (headers) {
      req.headers = headers;
    }
    if (body) {
      req.body = body;
    }

    return req;
  }

  /**
   *
   * @param {*} response
   * @return {Promise}
   */
  static unpack(response) {
    return response.json()
      .then((data) => {
        if (data.success !== 'TRUE') {
          return Promise.reject(data.payload);
        }
        return data.payload;
      });
  }
}

export default BasicApiFormatter;
